import { Box } from '@mui/material'
import { useCurrentUser } from '../../../hooks/contexts/currentUserContext'
import TextParagraph from '../../../assets/components/TextParagraph'
import ActivateAccount from '../../ActivateAccount'
import { Instrument } from '../../../utils/types'
import Text from '../../../assets/components/Text'
import BasicButton from '../../../assets/components/BasicButton'
import FlashOnIcon from '@mui/icons-material/FlashOn'
import { useConnectedInstruments } from '../../../hooks/contexts/connectedInstrumentsContext'

import { useContext, useState } from 'react'
import { PolyglotContext } from '../../../polyglot/polyGlotContext'
import SettingsDialog from './SettingsDialog'
import SettingsIcon from '@mui/icons-material/Settings'
import OTADialog from '../OTA/OTADialog'
import { useOTAUpdateData } from '../../../hooks/contexts/otaUpdateContext'

const Instruments = () => {
    const { polyglot } = useContext(PolyglotContext)
    const [selectedInstrument, setSelectedInstrument] = useState<Instrument | undefined>(undefined)
    const [openOTADialog, setOpenOTADialog] = useState(false)
    const [otaDeviceId, setOtaDeviceId] = useState<string | null>(null)
    const currentUser = useCurrentUser()
    const connectedInstruments = useConnectedInstruments()
    const otaUpdateData = useOTAUpdateData()

    const instruments = currentUser?.customer?.instruments as Instrument[]

    function isConnected(deviceId: string): Instrument | undefined {
        return connectedInstruments.find((instrument: Instrument) => instrument.deviceId === deviceId)
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '20px' }}>
            {currentUser?.customer ? (
                <>
                    {instruments ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '2rem' }}>
                            <TextParagraph heading={polyglot.t('settings.license.headingConnectedInstruments')} />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'flex-start',
                                    gap: '3rem',
                                    flexWrap: 'wrap'
                                }}
                            >
                                {instruments.map(
                                    (instrument: Instrument) =>
                                        instrument.serialNr && (
                                            <Box key={instrument.deviceId} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                                                <Text>{instrument.serialNr}</Text>

                                                {isConnected(instrument.deviceId) !== undefined && (
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                                                        <Box>
                                                            <FlashOnIcon sx={{ color: 'green' }} />
                                                            {polyglot.t('settings.license.boxActive')}
                                                        </Box>

                                                        <BasicButton title={polyglot.t('settingDialog.heading')} variant="contained" startIcon={<SettingsIcon />} onClick={() => setSelectedInstrument(isConnected(instrument.deviceId))} />
                                                    </Box>
                                                )}
                                            </Box>
                                        )
                                )}
                            </Box>

                            {selectedInstrument && (
                                <SettingsDialog
                                    onStartOTA={(deviceId: string) => {
                                        setOtaDeviceId(deviceId)
                                        setOpenOTADialog(true)
                                        setSelectedInstrument(undefined) // closes settings dialog
                                    }}
                                    openSettingsDialog={!!selectedInstrument}
                                    polyglot={polyglot}
                                    instrument={selectedInstrument}
                                    onClose={() => setSelectedInstrument(undefined)}
                                />
                            )}
                        </Box>
                    ) : (
                        <TextParagraph heading={polyglot.t('settings.license.headingConnectedInstruments')} body={polyglot.t('settings.license.bodyConnectedInstruments')} />
                    )}
                </>
            ) : (
                <ActivateAccount />
            )}
            {openOTADialog && otaDeviceId && <OTADialog openOTADialog={openOTADialog} onClose={() => setOpenOTADialog(false)} otaUpdateData={otaUpdateData} deviceId={otaDeviceId} />}
        </Box>
    )
}
export default Instruments
